import { useBotbRAFContext } from "@/app/(custom-header)/botb-refer-a-friend/context";

function Milestones() {
  const { statistics, viewDetailsClick } = useBotbRAFContext();

  const t: any = {
    milestonesTitle: "🚀 BONUS: Complete the 7 milestones to earn £410 extra!",
    milestonesCompleted: "Milestones Completed",
    btn: "View details",
  };

  return (
    <div className="w-full max-w-[694px] flex flex-col items-center gap-2.5 lg:gap-4 font-jost">
      <div
        className={
          "self-stretch text-primary text-base font-bold leading-[22px] lg:text-2xl lg:font-semibold lg:leading-[30px]"
        }>
        {t.milestonesTitle}
      </div>
      <div className={"flex justify-between items-center self-stretch bg-[#F5F5F5] pl-2 py-3 pr-3 lg:p-4 rounded-lg"}>
        <div className={"flex items-center gap-2"}>
          <img
            src={"/assets/images/refer-a-friend/milestones-icon.webp"}
            alt="milestones icon"
            className="size-8 lg:size-12 shrink-0"
            width={48}
            height={48}
          />
          <span className={"text-[#696971] text-xs font-normal leading-4 lg:text-base lg:leading-[22px]"}>
            <span className={"text-[#28282B] font-medium"}>
              {statistics.filter(item => item.tasks?.[0]?.is_completed === true).length}
            </span>
            /{statistics.length} {t.milestonesCompleted}
          </span>
        </div>
        <div>
          <button
            onClick={viewDetailsClick}
            className={
              "theme-btn theme-btn-blue theme-btn-xs min-w-[97px] lg:min-w-[129px] lg:theme-btn-4lg rounded-lg"
            }>
            {t.btn}
          </button>
        </div>
      </div>
    </div>
  );
}

export default Milestones;
